(function () {
  function getModal() {
    return document.getElementById('moq-modal');
  }

  function showMoqPopup(moq, productTitle) {
    const modal = getModal();
    const msg = document.getElementById('moq-modal__message');
    msg.textContent = `${productTitle ? productTitle + ' is' : 'This product is'} available as a ${moq}-pack. Please enter a multiple of ${moq}.`;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const modal = getModal();
    document.getElementById('moq-modal__close')?.addEventListener('click', () => modal.close());

    const lastValid = new WeakMap();

    function isValid(input, moq) {
      const val = parseInt(input.value, 10);
      if (isNaN(val)) return false;
      if (val === 0) return true;
      return val > 0 && val % moq === 0;
    }

    function attach(input) {
      const moq = parseInt(input.dataset.minOrderQty, 10) || 1;
      if (moq <= 1) return;

      lastValid.set(input, isValid(input, moq) ? input.value : String(moq));

      if (input.dataset.moqContext === 'product') return;

      input.addEventListener('change', function (e) {
        if (!isValid(input, moq)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.value = lastValid.get(input);
          showMoqPopup(moq, input.dataset.productTitle);
        } else {
          lastValid.set(input, input.value);
        }
      }, { capture: true });
    }

    document.querySelectorAll('input.quantity__input[data-min-order-qty]').forEach(attach);

    // Snap product-page quantity to MOQ default after Dawn initializes
    document.querySelectorAll('input.quantity__input[data-min-order-qty][data-moq-context="product"]')
      .forEach(function (input) {
        const moq = parseInt(input.dataset.minOrderQty, 10) || 1;
        if (moq <= 1) return;
        setTimeout(function () {
          const val = parseInt(input.value, 10);
          if (isNaN(val) || val < moq || val % moq !== 0) input.value = String(moq);
        }, 300);
      });

    // Re-snap on variant change (Dawn resets qty when switching variants)
    document.addEventListener('change', function (e) {
      const variantSelect = e.target?.closest('[name="id"]');
      if (!variantSelect) return;
      const section = variantSelect.closest('[id^="MainProduct"]');
      if (!section) return;
      const qtyInput = section.querySelector('input.quantity__input[data-min-order-qty][data-moq-context="product"]');
      if (!qtyInput) return;
      const moq = parseInt(qtyInput.dataset.minOrderQty, 10) || 1;
      if (moq <= 1) return;
      setTimeout(function () {
        const val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < moq || val % moq !== 0) qtyInput.value = String(moq);
      }, 50);
    }, true);

    // Handle inputs added later (cart drawer re-renders, ajax updates, quick-add modals)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          node.querySelectorAll?.('input.quantity__input[data-min-order-qty]').forEach(attach);
          if (node.matches?.('input.quantity__input[data-min-order-qty]')) attach(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Primary guard: click listener on Add to Cart / Buy it Now button
    // More reliable than submit event for Dawn's fetch-based product-form
    document.addEventListener('click', function (e) {
      const btn = e.target?.closest('button[name="add"], .product-form__submit');
      if (!btn) return;
      const form = btn.closest('form') || btn.form;
      if (!form) return;
          const formId = form.getAttribute('id');
      const qtyInput = (formId
        ? document.querySelector(`input.quantity__input[data-min-order-qty][form="${formId}"]`)
        : null) || form.querySelector('input.quantity__input[data-min-order-qty]');
      if (!qtyInput) return;
      const moq = parseInt(qtyInput.dataset.minOrderQty, 10) || 1;
      if (moq > 1 && !isValid(qtyInput, moq)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMoqPopup(moq, qtyInput.dataset.productTitle);
      }
    }, { capture: true });

    // Fallback: also catch via form submit event
    document.querySelectorAll('product-form form, form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', function (e) {
            const formId = form.getAttribute('id');
        const qtyInput = (formId
          ? document.querySelector(`input.quantity__input[data-min-order-qty][form="${formId}"]`)
          : null) || form.querySelector('input.quantity__input[data-min-order-qty]');
        if (!qtyInput) return;
        const moq = parseInt(qtyInput.dataset.minOrderQty, 10) || 1;
        if (moq > 1 && !isValid(qtyInput, moq)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showMoqPopup(moq, qtyInput.dataset.productTitle);
        }
      }, { capture: true });
    });

    /* ----------------------------------------------------------------------
       Flag quantities that are ALREADY wrong when the cart renders.

       attach() above only listens for `change`, so a line added by quick-add —
       which posts quantity 1 with no quantity input to validate — sits in the
       cart silently. The buyer discovers it only when they try to check out, or
       on a PunchOut session when the cart return is refused by the server.

       This marks offending lines on sight, and blocks the two exits: Shopify
       checkout, and Return to Procurement.
    ---------------------------------------------------------------------- */

    var MOQ_ERR_CLASS = 'moq-line-error';

    function cartQtyInputs() {
      return Array.prototype.slice.call(
        document.querySelectorAll('input.quantity__input[data-min-order-qty]')
      ).filter(function (input) {
        // The product page has its own submit-time guard and a step attribute.
        return input.dataset.moqContext !== 'product';
      });
    }

    function markInput(input, moq, bad) {
      input.style.borderColor = bad ? '#e53e3e' : '';
      input.style.background  = bad ? '#fff5f5' : '';

      var holder = input.closest('.cart-item, .cart-drawer__item, tr, li') || input.parentElement;
      if (!holder) return;

      var note = holder.querySelector('.' + MOQ_ERR_CLASS);
      if (bad) {
        if (!note) {
          note = document.createElement('div');
          note.className = MOQ_ERR_CLASS;
          note.style.cssText = 'color:#e53e3e;font-size:12px;font-weight:600;margin-top:6px;line-height:1.4;';
          (input.closest('.quantity') || input.parentElement).insertAdjacentElement('afterend', note);
        }
        note.textContent = 'Sold in packs of ' + moq + ' — change the quantity to a multiple of ' + moq + '.';
      } else if (note) {
        note.remove();
      }
    }

    function cartViolations() {
      var bad = [];
      cartQtyInputs().forEach(function (input) {
        var moq = parseInt(input.dataset.minOrderQty, 10) || 1;
        if (moq <= 1) return;
        var val = parseInt(input.value, 10);
        // 0 means "remove this line" and is legitimate in a cart.
        var invalid = !isNaN(val) && val !== 0 && val % moq !== 0;
        markInput(input, moq, invalid);
        if (invalid) bad.push((input.dataset.productTitle || 'An item') + ': ' + val + ' ordered, needs a multiple of ' + moq);
      });
      return bad;
    }

    function checkoutButtons() {
      return Array.prototype.slice.call(document.querySelectorAll(
        'button[name="checkout"], #checkout, .cart__checkout-button, [name="checkout"]'
      ));
    }

    function revalidateCart() {
      var bad = cartViolations();
      checkoutButtons().forEach(function (btn) {
        btn.disabled = bad.length > 0;
        btn.style.opacity = bad.length ? '0.5' : '';
        btn.style.cursor  = bad.length ? 'not-allowed' : '';
        btn.title = bad.length ? 'Adjust the highlighted quantities to continue' : '';
      });
      return bad;
    }

    /* Gate the PunchOut return. theme.liquid exposes sendPunchoutCart as a global
       and the button calls it directly, so wrapping the function is more reliable
       than guessing the button's selector. The server refuses a bad cart anyway —
       this just tells the buyer before the round trip instead of after. */
    if (typeof window.sendPunchoutCart === 'function' && !window.sendPunchoutCart.__moqWrapped) {
      var originalSend = window.sendPunchoutCart;
      window.sendPunchoutCart = function () {
        var bad = revalidateCart();
        if (bad.length) {
          if (typeof window.showPunchoutMoqError === 'function') {
            window.showPunchoutMoqError(
              'Some items need their quantity adjusted before the cart can be sent back.', bad
            );
          } else {
            alert('Adjust these quantities before returning the cart:\n\n' + bad.join('\n'));
          }
          return;
        }
        return originalSend.apply(this, arguments);
      };
      window.sendPunchoutCart.__moqWrapped = true;
    }

    revalidateCart();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input.quantity__input[data-min-order-qty]')) {
        setTimeout(revalidateCart, 0);
      }
    }, true);

    // The cart drawer re-renders over AJAX; re-check whenever the DOM settles.
    var revalidateSoon;
    new MutationObserver(function () {
      clearTimeout(revalidateSoon);
      revalidateSoon = setTimeout(revalidateCart, 120);
    }).observe(document.body, { childList: true, subtree: true });

  });
})();